export class MvsFormContentDto {
    id?: number;

    objectType: string;
    objectTypeId: number;
    objectTypeName: string;

    as: string;

    genericType: boolean;
    genericTypeId: number;
    genericTypeName: string;

    // 03/2026 Entity label (always present, from @UiEntityInfo or synonym fallback)
    entityLabel?: string;

    // 03/2026 AI metadata (present when resolveAiMeta=true)
    aiInfo?: {
        entityRole?: string;
        synonyms?: string[];
        description?: string;
    };
}